<template>
  <div :class="[ 'lines', item.classes.wrapper ]">
    <div :class="[
      'line', 'line-root',
      item.classes.root
    ]">
      <div :class="[
        'line', 'line-tail',
        item.classes.tail
      ]">
        <div :class="item.classes.indicator"></div>
      </div>
    </div>
    <div class="line line-short"></div>
    <div class="line line-long"></div>
  </div>
</template>

<script>
export default {
  name: 'NodeCalloutLines',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>
